import { render, staticRenderFns } from "./SharedList.vue?vue&type=template&id=38ccc2e6&"
import script from "./SharedList.vue?vue&type=script&lang=js&"
export * from "./SharedList.vue?vue&type=script&lang=js&"
import style0 from "./SharedList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports